import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withDocuments } from "src/modules/document/operations";

import { withStateAndActionsForDocument } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, documents, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"documents"}
            component={RenderSelect}
            placeholder={"Documents"}
            label={"Documents"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(documents?.map((document) => ({
                    id: document.id,
                    label: document.name || "",
                    value: JSON.stringify(document),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(
    withStateAndActionsForDocument,
    withDocuments,
)(SubjectsField);
